export const ConfigComponent = () => {
  console.log(`Skipping rendering of config as component.`)
  return null
}

export default ConfigComponent
